jQuery(".checkout input").each(function(index, elem) {
   var eId = jQuery(elem).attr("id");
   var label = null;
   if (eId && (label = jQuery(elem).parents("form").find("label[for="+eId+"]")).length == 1) {
       jQuery(elem).attr("placeholder", jQuery(label).html().replace(/(<([^>]+)>)/ig,""));
   }
});

jQuery('.checkout #billing_country_field, .checkout #billing_address_1_field, .checkout #billing_address_2_field, .checkout #billing_city_field, .checkout #billing_state_field, .checkout #billing_postcode_field').prependTo('.checkout .col-2');



// WEBPACK FOOTER //
// ./assets/js/woocomerce.js